export const initialState = {
	navigation: { type: 'credit' },
};
